
import React, { useEffect, useRef, useState, useMemo } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { AgGridReact } from 'ag-grid-react';
import { fetchGridLayout, getDecoder, getHyphenDDMMMYYYYHHMM, saveGridLayout,statusMessages } from '../common/utils';
import ResendConsentRenderer from './ResendConsentRenderer.js'
import EditSimTracking from './editsimtracking.js'
import AttendedButtonRenderer from './AttendedButtonRenderer';
import redirectURL from "../redirectURL";
const SimTracking = () => {
	const gridColumnApi = useRef(null)
	const savedRef = useRef(null)
	const user = useMemo(() => getDecoder(), []);
	const [sweetAlert, setSweetAlert] = useState({
		type: null,
		title: '',
		show: false
	});
	const [searchMobileNo, setSearchMobileNo] = useState('');
	const [slider, setSlider] = useState({
		sliderTranslate: '',
		overly: "show-n"
	})
	const [sliderText, setSliderText] = useState("")
	const [rowData, setRowData] = useState([])
	const [driverName, setDriverName] = useState('')
	const [driverMobile, setDriverMobile] = useState("")
	const [assignedTruckNo, setAssignedTruckNo] = useState('')
	const [rowid, setRowId] = useState('')
	const [errMsg, setErrMsg] = useState('')
	const [loading, setLoading] = useState({
		loadshow: 'show-n',
		overly: 'show-n'
	})
	const [loadshow,setLoadShow] = useState('show-n')
	const defaultColDef = useMemo(() => {
		return {
			sortable: true,
			filter: true,
			autoSizeColumns: true,
			resizable: true,
			pivot: true,
		}
	});
	const columnwithDefs = useMemo(() => {
		return [
			{
				headerName: "Driver Name",
				field: "driver_name",
				width: 120,
				pinned: "left"
			},
			{
				headerName: "Mobile Number",
				field: "driver_mobile_no",
				pinned: "left",
				width:120
			},
			{
				headerName: "Assigned Truck",
				field: "assigned_truck_no",
				width: 150,
				pinned: "left"
			},
			{
				headerName: "Sim Consent Status",
				field: "last_consent_status",
				width: 128,
				pinned: "left",
				valueGetter: function (params) {
					try {
						return ([1, 2, 14].includes(params.data.last_consent_status) ? "Not Registered" :
							[3, 18, 9].includes(params?.data?.last_consent_status) ? "Approved" :
								[4, 7, 12, 15, 16, 17, 19, 20, 21, 23, 24, 25, 26].includes(params?.data?.last_consent_status) ? "Consent Approved" :
									[5, 6, 11, 22].includes(params?.data?.last_consent_status) ? "Consent Pending" :
										[8, 10].includes(params?.data?.last_consent_status) ? "Cosent Declined" :
											[13].includes(params?.data?.last_consent_status) ? "Error" :
												[14].includes(params?.data?.last_consent_status) ? "Not Registered" : '');
					}
					catch (e) {
						return ("error", e)
					}
				},
			},
			{
				headerName: "Resend Consent",
				field: "resend",
				width: 150,
				cellRenderer: ResendConsentRenderer
			},
			{
				headerName: "Action",
				field: "_id",
				width: 120,
				cellRenderer: EditSimTracking,
			},
			{
				headerName: "Remarks",
				field: "last_consent_status",
				width: 200,
				valueGetter: function (params) {
					try {
						return statusMessages[params?.data?.last_consent_status] || "";
					}
					catch (e) {
					}
				},
			},
			{
				headerName: "Resend Consent On",
				field: "resend_on",
				width: 170,
				valueGetter: function (params) {
					try {
						return !["",undefined,null].includes(params.data.resend_on) ? getHyphenDDMMMYYYYHHMM(params.data.resend_on) : ''
					}
					catch (e) {
					}
				},
				editable: false
			},
			{
				headerName: "Service Provider",
				field: "prob_service_provider"
			},
			{
				headerName: "Attended",
				field: "verified",
				width: 150,
				cellRenderer: AttendedButtonRenderer,
			},
			{
				headerName: "Attended On",
				field: "mark_as_verified_on",
				width: 150,
				valueGetter: function (params) {
					try {
						return !['',null,undefined].includes(params.data.mark_as_verified_on)? getHyphenDDMMMYYYYHHMM(params.data.mark_as_verified_on) : ''
					}
					catch (e) {
					}
				},
			},
			{
				headerName: "Created On",
				field: "created_on",
				width: 150,
				valueGetter: function (params) {
					try {
						return !['',null,undefined].includes(params.data.created_on) ?getHyphenDDMMMYYYYHHMM(params.data.created_on) : ''
					}
					catch (e) {
					}
				},
			},

			{
				headerName: "Modified On",
				field: "modified_on",
				width: 150,
				valueGetter: function (params) {
					try {
						return !['',null,undefined].includes(params.data.modified_on) ? getHyphenDDMMMYYYYHHMM(params.data.modified_on) : ''
					}
					catch (e) {
					}
				},
			},
		]
	}, []);
	useEffect(() => {
		loadData()
	}, [])
	const saveGrid = async (e) => {
		let coloumnState = gridColumnApi.current.api?.getColumnState()
		savedRef.current = coloumnState
		if (user != "" && user?.email != undefined) {
			let temp = await saveGridLayout(user?.email, "simtracking", coloumnState)
			if (temp.data.status == "success") {
				setSweetAlert({
					show: true,
					type: 'success',
					title: 'Grid Saved Successfully'
				})
			}
			else {
				setSweetAlert({
					show:true,
					type:'danger',
					title:"Failed to Save grid"
				})
			}
		}
	}
	const resetGrid = async () => {
		let coloumnState = []
		if (user != "" && user.email != undefined) {
			let temp = await saveGridLayout(user?.email, "simtracking", coloumnState)
			if (temp.data.status == "success") {
				setSweetAlert({
					type:'success',
					show:true,
					title:'Grid successfully reset'
				})
				gridColumnApi.current.api.resetColumnState()
			}
			else {
				setSweetAlert({					
					show: true,
					basicTitle: "Failed to reset grid",
					basicType: "danger"
				});
			}
		}
	}
	const onSearchMobileNo = async (event) => {
		if (!!searchMobileNo) {
			setLoadShow("show-m")
			await redirectURL.get('/getSimTrackingDrivers', { params: { mobile_no: searchMobileNo } })
				.then((response) => {
					setRowData(response?.data?.drivers ?? [])
					setLoadShow("show-n")
				})
				.catch(function (error) {
					return error
				})
		}
	}
	const loadData = async () => {
		let params = {}
		setLoadShow("show-m")
		await redirectURL.get("/getSimTrackingDrivers", params)
			.then(async (resp) => {
				if (resp.data?.status == 'success') {
					setRowData(resp.data?.drivers)
					setLoadShow("show-n")
				}
				else {
					setLoadShow("show-n")
					setRowData([])
				}
			await fetchGridLayout(user.email, "simtracking").then((response) => {
			let columnAPI = '';
			if (response.data.status == 'success') {
                columnAPI = gridColumnApi.current.api
				setTimeout(async () => {
					await columnAPI.applyColumnState({
						state: response.data.data[0].columnState,
						applyOrder: true,
					})
				}, 1500);
			}
		})})
	}
	const onConfirm = () => {
		setSweetAlert({
			type: "",
			show: false,
			title: ''
		})
		if(sweetAlert?.title== 'Grid Saved Successfully')
		setTimeout(async () => {
                await gridColumnApi.current.api.applyColumnState({
                    state: savedRef.current,
                    applyOrder: true,
                })
            }, 1000);
	}
	const onCLickAddDriver = (e) => {
		setSlider({
			sliderTranslate: 'slider-translate',
			overly: 'show-m'
		})
		!!e.target ? setSliderText("Add Driver") : setSliderText("Edit Driver")
		!!e.data &&
		setDriverName(e.data?.driver_name)
		setDriverMobile(e.data?.driver_mobile_no)
		setAssignedTruckNo(e.data?.assigned_truck_no)
		setRowId(e.data?._id)
	}
	const changeMobileNoHandler = (e) => {
		const value = e.target.value.replace(/[^0-9]/g, "");;
		const regex = /^[6-9][0-9]{0,9}$/; // starts with 6–9, up to 10 digits
		if (value === "" || regex.test(value)) {
			setDriverMobile(value); // ✅ store actual number
		}
	};
	const changeVehicleNo = (e) => {
		let value = e.target.value;
		value = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
		setAssignedTruckNo(value)
	}
	const mobileValidation = (e) => {
			(driverMobile.length < 10) ?
			setErrMsg("Invalid Mobile Number") : setErrMsg('')
	}
	const saveDriver = (e) => {
		e.preventDefault();
		var params = {
			driver_name: driverName,
			mobile_no: driverMobile,
			assigned_truck_no: assignedTruckNo,
		}
		if (sliderText == 'Add Driver') {
			redirectURL.post("/adddriver", params)
				.then((response) => {
					if (response.data.status === "Success") {
						setSweetAlert({
							show: true,
							type: "success",
							title: "Driver Added Successfully"
						})
					}
					else {
						setSweetAlert({
							show: true,
							type: "danger",
							title: response.data.message
						})
					}
					loadData()
				})
		}
		else if (sliderText == 'Edit Driver') {
			params.rowid = rowid
			redirectURL.post("/updatedriver", params).then((response) => {
				if (response.data.status == 'success') {
					setSweetAlert({
						type: 'success',
						show: true,
						title: 'Driver Updated Successfully'
					})
				}
				else {
					setSweetAlert({
						show: true,
						type: 'danger',
						title: 'Failed to Update '
					})
				}
				loadData()
			})
		}
		setSlider({
			setSlider: "",
			sliderText: ""
		})
	}
	const onCellClicked = async (params) => {
		if (params.colDef.field === "resend") {
			setLoading({
				loadshow: 'show-m',
				overly: "show-m"
			})
			let param = params.data
			redirectURL.post("/resendconsent", param).then((response) => {
				if (response.data.status == 'Success') {
					setSweetAlert({
						show: true,
						title: response?.data?.message,
						type: 'success'
					})
					setLoading({
						overly: 'show-n',
						loadshow: 'show-n'
					})
					loadData()
				}
				else {
					setSweetAlert({
						show: true,
						title: response.data.message,
						type: 'danger'
					})
					setLoading({
						overly: 'show-n',
						loadshow: 'show-n'
					})
				}
			})
		}
		if (params.colDef.field == "verified") {
			setLoading({
				overly: 'show-m',
				loadshow: "show-m"
			})
			redirectURL.post("/verifyconsent", params.data).then((response) => {
				if (response.data.message === "Success") {
					setLoading({
						loadshow: 'show-n',
						overly: 'show-n'
					})
					setSweetAlert({
						show: true,
						title: response.data.message,
						type: 'success'
					})
					loadData();
				}
				else {
					setLoading({
						overly: 'show-n',
						loadshow: 'show-n'
					})
					setSweetAlert({
						show: true,
						title: response.data.message,
						type: 'danger'
					})
				}
			})
		}
	}
	const onCloseModal = async (params) => {
		setSlider({
			sliderTranslate: '',
			sliderText: ''
		})
		setDriverName('')
		setDriverMobile('')
		setAssignedTruckNo('')
	}
	return (
		<>
			<div className='container-fluid'>
				<SweetAlert
					show={sweetAlert?.show}
					type={sweetAlert?.type}
					title={sweetAlert?.title}
					onConfirm={onConfirm}>
				</SweetAlert>
				<div className="col-xl-12 col-lg-12" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
					<h5 style={{ margin: 0 }}>
						<i className="icofont icofont-vehicle-delivery-van cus-i"></i> <span>SIM Tracking Numbers</span>
					</h5>
					<div className="button-group" style={{ display: "flex", justifyContent: "flex-end" }}>
						<button type="button" onClick={onCLickAddDriver} className="btn btn-warning" style={{ marginRight: "10px" }}>
							Add Driver
						</button>
						<button type="button" title="Save Grid Layout" name="savegrid" className="btn btn-success float-right action_btn" style={{ marginLeft: "10px" }} onClick={saveGrid}> <i className="fa fa-save"></i> </button>
						<button type="button" title="Reset Grid Layout" name="resetgrid" className="btn btn-info float-right action_btn" style={{ marginLeft: "10px" }} onClick={resetGrid}> <i className="fa fa-reply"></i> </button>
					</div>
				</div>
				<br />
				<div className="row">
					<div className="col-xl-12 col-lg-12" >
						<div className="card">
							<div className="card-body">
								<div className="col4 mb-3" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
									<span>Mobile No.</span>
									<input type="text" value={searchMobileNo} maxLength={10} onChange={e => setSearchMobileNo(isNaN(parseInt(e.target.value)) ? "" : parseInt(e.target.value))} autoComplete="off" class="form-control" style={{ width: "200px" }}></input>
									<button type="button" onClick={onSearchMobileNo} className="btn btn-success">Search</button>
									<button type="button" onClick={e => window.location.reload()} className="btn btn-warning">Reset</button>
								</div>
								<div id="dynamic-grid" style={{ height: "550px", width: "100%" }} className="ag-theme-balham">
									<AgGridReact
										ref={gridColumnApi}
										columnDefs={columnwithDefs}
										defaultColDef={defaultColDef}
										frameworkComponents={{ attendedButtonRenderer: AttendedButtonRenderer }}
										paginationPageSize={50}
										pagination={true}
										rowData={rowData}
										stopEditingWhenGridLosesFocus={true}
										suppressCellFlash={true}
										context={{ componentParent: { onCLickAddDriver } }}
										onCellClicked={onCellClicked}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				{slider.sliderTranslate && <div className={"slide-r " + (slider?.sliderTranslate)} style={{ overflow: "auto" }}>
					<div className="slide-r-title">
						<h4>
							{sliderText}
							<span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={onCloseModal} >X</span>
						</h4>
					</div>
					<div className="slide-r-body" style={{ position: "relative" }}>
						<div className="row col-xl-12 col-lg-12 ml-0p n-p-0"></div><div className={"row"} style={{ padding: '5px 0px', width: '100%', zIndex: '9999', }} >
							<form method="POST" className="theme-form col-xl-12 col-lg-12" onSubmit={saveDriver}>
								<div className="col-12 form-group">
									<label className=""> Driver Name <span className='mandatory_field'>*</span></label>
									<input type="text" placeholder="Enter Driver Name" autoComplete='off'
										onChange={(event) => {
											let value = event.target.value;
											if (value.length > 0) {
												value = value.charAt(0).toUpperCase() + value.slice(1);
											}
											setDriverName(value)
										}}
										value={driverName}
										id="driver_name" name="driver_name" className="form-control" required
									/>
								</div>

								<div className="col-12 form-group">
									<label className=""> Driver Mobile Number <span className='mandatory_field'>*</span></label>
									<input
										type="text"
										placeholder="Enter Mobile Number"
										onChange={changeMobileNoHandler}
										onBlur={mobileValidation}
										autoComplete='off'
										maxLength={10}
										value={driverMobile}
										id="mobile_no"
										name="mobile_no"
										className="form-control"
										required
									/>
									{
										<span style={{ fontSize: "11px", color: "#ff0000", marginTop: "5px", display: "block" }}>
											{errMsg}
										</span>}
								</div>
								<div className="col-12 form-group">
									<label className="">Vehicle No <span className='mandatory_field'>*</span> </label>
									<input type="text"
										placeholder="Enter Vehicle No"
										autoComplete='off'
										onChange={changeVehicleNo}
										value={assignedTruckNo}
										id="assigned_truck_no"
										name="assigned_truck_no"
										className="form-control"
										required />
								</div>
								<div className="col-12 form-group d-flex justify-content-center">
									<button type="submit" className="btn btn-success">Submit</button>
								</div>
							</form>
						</div>
					</div>
				</div>}
				<div className={"dataLoadpage " + (loadshow)}></div>
				<div className={"dataLoadpageimg " + (loadshow)} style={{ top: "21em" }}>
					<div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
				</div>
			</div>
		</>
	)
}

export default SimTracking
